import { render, staticRenderFns } from "./ActivateCode.vue?vue&type=template&id=6a2e6664&scoped=true&"
import script from "./ActivateCode.vue?vue&type=script&lang=js&"
export * from "./ActivateCode.vue?vue&type=script&lang=js&"
import style0 from "./ActivateCode.vue?vue&type=style&index=0&id=6a2e6664&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a2e6664",
  null
  
)

export default component.exports